import * as Menubar from '@radix-ui/react-menubar';
import { VariantProps, cva } from 'class-variance-authority';
import { textVariants } from '../Text/Text';

export const OverflowMenu = (props: Menubar.MenubarProps) => {
  return (
    <Menubar.Root>
      <Menubar.Menu {...props} />
    </Menubar.Root>
  );
};

const overflowMenuContent = cva(
  'relative bg-surface-strong min-w-[240px] max-h-[266px] overflow-y-auto rounded-s shadow-l',
  {
    variants: {
      padding: {
        default: 'p-xxs',
        none: 'p-none',
      },
    },
    defaultVariants: {
      padding: 'default',
    },
  },
);

const OverflowMenuContent = (
  props: Menubar.MenubarContentProps & VariantProps<typeof overflowMenuContent>,
) => {
  return (
    <Menubar.Portal>
      <Menubar.Content
        aria-label="Overflow Menu Content"
        className={overflowMenuContent({ padding: props.padding })}
        sideOffset={8}
        {...props}
      />
    </Menubar.Portal>
  );
};

const overflowMenuItem = cva(
  'font-normal px-m py-s rounded-xs data-[highlighted]:bg-hover-opacity active:bg-active-opacity hover:cursor-pointer focus-visible:outline-hidden',
  {
    variants: {
      intent: {
        default: '',
        destructive: textVariants.color.contentNegative,
      },
    },
    defaultVariants: {
      intent: 'default',
    },
  },
);

export type MenuItemIntent = NonNullable<
  VariantProps<typeof overflowMenuItem>['intent']
>;

const OverflowMenuItem = ({
  intent,
  ...props
}: Menubar.MenubarItemProps & VariantProps<typeof overflowMenuItem>) => {
  return (
    <Menubar.Item
      aria-label={props['aria-label']}
      className={`${overflowMenuItem({ intent })} data-[disabled]:text-content-disabled data-[disabled]:cursor-not-allowed data-[disabled]:hover:cursor-not-allowed data-[disabled]:data-[highlighted]:bg-transparent data-[disabled]:active:bg-transparent`}
      {...props}
      onClick={props.disabled ? undefined : props.onClick}
    />
  );
};

const OverflowMenuTrigger = (props: Menubar.MenubarTriggerProps) => {
  return <Menubar.Trigger asChild aria-label="Open Overflow Menu" {...props} />;
};

OverflowMenu.Content = OverflowMenuContent;
OverflowMenu.Item = OverflowMenuItem;
OverflowMenu.Trigger = OverflowMenuTrigger;
OverflowMenu.Separator = Menubar.Separator;
